import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
import EditEmailModal from "@/shared/components/channels/EditEmailModal.vue";
import { updateOrganisationCommunicationChannel } from "../../infrastructure/api/organisationApi";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrganisationEditEmailModal',
    props: /*@__PURE__*/ _mergeModels({
        organisationId: {},
        channelId: {},
        initialValue: {},
        initialIsPrimary: { type: Boolean }
    }, {
        "modelValue": { type: Boolean, ...{ default: false } },
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(["updated", "delete"], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        const props = __props;
        const open = _useModel(__props, "modelValue");
        const emit = __emit;
        function submitEmail(payload) {
            return updateOrganisationCommunicationChannel(props.organisationId, props.channelId, {
                type: "Email",
                value: payload.value,
                isPrimary: payload.isPrimary,
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(EditEmailModal, {
                modelValue: open.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((open).value = $event)),
                "initial-value": __props.initialValue,
                "initial-is-primary": __props.initialIsPrimary,
                submit: submitEmail,
                "i18n-prefix": "organisation.detail.editEmail",
                "field-i18n-prefix": "organisation.detail.addEmail",
                onUpdated: _cache[1] || (_cache[1] = ($event) => (emit('updated'))),
                onDelete: _cache[2] || (_cache[2] = ($event) => (emit('delete')))
            }, null, 8 /* PROPS */, ["modelValue", "initial-value", "initial-is-primary"]));
        };
    }
});
